export default __webpack_public_path__ + "static/media/NEAS0570.34I-37752_-22114_0.5d6b7d67.jpg";